// frontend/src/pages/Services.jsx
import React, { useEffect, useState, useCallback } from "react";
//import { Link } from 'react-router-dom';
import { getServices, getCategories } from "../services/api";
import ImageZoom from "../components/ImageZoom";
//import { FaArrowRight } from 'react-icons/fa';

const Services = () => {
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const params = { published: true };
      if (selectedCategory) params.category = selectedCategory;

      const [servicesRes, categoriesRes] = await Promise.all([
        getServices(params),
        getCategories(),
      ]);

      setServices(servicesRes.data);
      setCategories(categoriesRes.data);
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedCategory]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="py-12 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Nos Services
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Découvrez notre gamme complète de services d'ingénierie
          </p>
        </div>

        {/* Filtres par catégorie */}
        {categories.length > 0 && (
          <div className="mb-8 flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => setSelectedCategory("")}
              className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                selectedCategory === ""
                  ? "bg-blue-600 text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
            >
              Tous
            </button>
            {categories.map((category) => (
              <button
                key={category._id}
                onClick={() => setSelectedCategory(category._id)}
                className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                  selectedCategory === category._id
                    ? "bg-blue-600 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        )}

        {/* Grille des services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service._id}
              className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <ImageZoom
                src={`${
                  process.env.REACT_APP_API_URL ||
                  "https://api.seengineering-tn.com"
                }${service.image}`}
                alt={service.title}
                className="h-70 object-cover"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-gray-800">
                    {service.title}
                  </h3>
                  {service.category && (
                    <span className="px-3 py-1 bg-blue-100 text-blue-600 text-sm rounded-full">
                      {service.category.name}
                    </span>
                  )}
                </div>
                <p
                  className="text-gray-600 mb-4"
                  style={{ textAlign: "justify" }}
                >
                  {service.description}
                </p>
                {service.features && service.features.length > 0 && (
                  <ul className="mb-4 space-y-1">
                    {service.features.slice(0, 3).map((feature, index) => (
                      <li
                        key={index}
                        className="text-gray-600 text-sm flex items-start"
                      >
                        <span className="text-blue-600 mr-2">•</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                )}
                {/* <Link
                  to={`/services/${service._id}`}
                  className="text-blue-600 hover:text-blue-700 font-semibold inline-flex items-center gap-2"
                >
                  En savoir plus
                  <FaArrowRight size={14} />
                </Link> */}
              </div>
            </div>
          ))}
        </div>

        {services.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">
              Aucun service trouvé dans cette catégorie.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
